 import { Injectable } from '@angular/core';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
import { BehaviorSubject, Observable, of, ReplaySubject, Subject } from 'rxjs';
import { dataUrlMethod } from 'app/components/datagrid/datagrid.interface';
import { NgEventBus } from 'ng-event-bus';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class JobsService {
    jobDetailsLoaded: Subject<boolean> = new Subject<boolean>();
    taskAssignment: Subject<any> = new Subject<any>();
    taskAssignedEmployee: ReplaySubject<any> = new ReplaySubject<any>(1);
    defaultFilterOptions = {
        filterOptions: {
            group_by: 'created_at',
            sort: 'DESC',
            sort_by: 'created_at',
            include_thumbnail: true,
            thumbnail_resolution: 'md',
            'filter.module': 'JOB',
            'filter.module_uid': '',
            'filter.from_date': '',
            'filter.to_date': '',
            'filter.created_by': '',
            'filter.type': ''
        }
    };
    private attachmentCountSubject = new BehaviorSubject<number>(0);
    public attachmentCount$: Observable<number> = this.attachmentCountSubject.asObservable();
    get holidayUrl(): string{
        return `${this.dataCollectorService.baseurl()}/company/holidays`;
    }
    get jobAPIUrls(): any{
        return {
            jobsUrl: `${this.dataCollectorService.baseurl()}/jobs`,
            projectsUrl: `${this.dataCollectorService.baseurl()}/projects`,
            invoiceUrl: `${this.dataCollectorService.baseurl()}/invoice`,
            estimateUrl: `${this.dataCollectorService.baseurl()}/estimate`,
            contractUrl: `${this.dataCollectorService.baseurl()}/service_contract`,
            recurringJobsUrl: `${this.dataCollectorService.baseurl()}/recurring_jobs/filter`,
            recurringJobsFilterUrl: `${this.dataCollectorService.baseurl()}/recurring_jobs/meta/filter`,
            dataUrl: `${this.dataCollectorService.baseurl()}/jobs/filter`,
            columnUrl: `${this.dataCollectorService.baseurl()}/jobs/meta`,
            filterUrl: `${this.dataCollectorService.baseurl()}/jobs/meta/filter`,
            bulkActionUrl: `${this.dataCollectorService.baseurl()}/jobs/bulk_action`,
            jobCategoryUrl: `${this.dataCollectorService.baseurl()}/jobs/category?populate_statuses=true`,
            templateUrl: `${this.dataCollectorService.baseurl()}/jobs/template`,
            scheduleDate: `${this.dataCollectorService.baseurl()}/jobs/schedule`,
            skills: `${this.dataCollectorService.baseurl()}/skills`,
            category: `${this.dataCollectorService.baseurl()}/jobs/category`,
            teamSummaryUrl: `${this.dataCollectorService.baseurl()}/teams/summary`,
            teamDetailsUrl: `${this.dataCollectorService.baseurl()}/team/work_mins`,
            allUsersUrl: `${this.dataCollectorService.baseurl()}/user/all`,
            assignEmployeeUrl: `${this.dataCollectorService.baseurl()}/jobs/assign`,
            recurringJobScheduleUrl: `${this.dataCollectorService.baseurl()}/recurring_job/schedule`,
            serviceTerritoryUrl: `${this.dataCollectorService.baseurl()}/territory`,
            assistedSchedulingUrl: `${this.dataCollectorService.baseurl()}/assisted_scheduling`,
            assignRoutesUrl: `${this.dataCollectorService.baseurl()}/routes`,
            dataUrlMethod: dataUrlMethod.POST,
            serviceTasks: `${this.dataCollectorService.baseurl()}/service_tasks`,
            serviceTaskUrl: `${this.dataCollectorService.baseurl()}/service_tasks`,
            inspectionFormURl: `${this.dataCollectorService.baseurl()}/assets/inspection_form/master`,
            reorderServiceTaskUrl: `${this.dataCollectorService.baseurl()}/service_tasks/reorder`,
            serviceTaskBulkActionUrl: `${this.dataCollectorService.baseurl()}/service_tasks/bulk_action`,
            attachmentCount: `${this.dataCollectorService.baseurl()}/attachments/count`
        };
    }

    get jobGridUrls(): any{
        return {
            columnUrl: `${this.dataCollectorService.baseurl()}/jobs/meta`,
            dataUrl: `${this.dataCollectorService.baseurl()}/jobs/filter`,
            filterUrl: `${this.dataCollectorService.baseurl()}/jobs/meta/filter`,
            bulkActionUrl: `${this.dataCollectorService.baseurl()}/jobs/bulk_action`
        };
    }

    refreshJobDetails: Subject<any> = new Subject();
    currentJobDetails = new BehaviorSubject<any>(null);
    selectedRoute: any = {};

    constructor(private dataCollectorService: DataCollectorService, private _eventBus: NgEventBus) {
        this.jobDetailsLoaded.next(false);
    }

    getJobUrl(jobId: string): string {
        return `${this.dataCollectorService.baseurl()}/jobs/${jobId}`;
    }

    getServiceTaskMaster(): string {
        return `${this.dataCollectorService.baseurl()}/service_tasks/master`;
    }

    getCategoryServiceTask(uid): string {
        return  `${this.jobAPIUrls.category}/${uid}/service_tasks`;
    }

    getTimelogUrl(jobId: string): string {
        return `${this.dataCollectorService.baseurl()}/jobs/${jobId}/timelog_summary`;
    }

    getUserTimelogUrl(userId: string): string {
        return `${this.dataCollectorService.baseurl()}/users/${userId}/timelog`;
    }

    getAllExpensesUrl(): string {
        return `${this.dataCollectorService.baseUrl}/expenses`;
    }

    getAllExpenseCategoriesUrl(): string {
        return `${this.dataCollectorService.baseUrl}/expenses/category`;
    }

    getAiScanDetailsUrl(): string {
        return `${this.dataCollectorService.baseUrl}/ai/scan`;
    }

    getJobNotesUrl(jobId: string): string {
        return `${this.dataCollectorService.baseurl()}/jobs/${jobId}/note`;
    }

    getRecurringJobDeleteURL(recurringJobId: string,deleteAssociated: boolean): string{
        return `${this.dataCollectorService.baseurl()}/recurring_jobs/${recurringJobId}?delete_associate_jobs=${deleteAssociated}&delete_future_jobs_only=${deleteAssociated}`;
    }

    getStatusRollBackUrl(jobId): string{
        return `${this.dataCollectorService.baseurl()}/jobs/${jobId}/status/rollback`;
    }

    getJobStatusUrl(categoryId: string): string{
        return `${this.dataCollectorService.baseurl()}/jobs/status/${categoryId}`;
    }

    getPostJobStatusUrl(jobId: string): string{
        return `${this.dataCollectorService.baseurl()}/jobs/${jobId}/status`;
    }

    getCategoryUrl(): string {
        return `${this.dataCollectorService.baseurl()}/jobs/category`;
    }

    getPrintSharePdfUrl(jobId: string): string{
        return `${this.getJobUrl(jobId)}/card`;
    }
    deleteURL(jobId: string): string{
        return `${this.dataCollectorService.baseurl()}/jobs/${jobId}/delete`;
    }

    deleteExpenseURL(expenseUid: string): string{
        return `${this.dataCollectorService.baseUrl}/expenses/${expenseUid}`;
    }

    sendjobTemplate(jobId,sendData): any{
        return this.dataCollectorService.postData(this.getPrintSharePdfUrl(jobId),sendData);
    }

    getTrackLocationUrl(jobId): string{
        return `${this.dataCollectorService.baseurl()}/location/job?job_uid=${jobId}`;
    }

    getChecklistUpdateUrl(jobId,statusId): string{
        return `${this.getPostJobStatusUrl(jobId)}/${statusId}/checklist`;
    }

    getTeamDetails(teamUid): string{
        return `${this.dataCollectorService.baseurl()}/team/${teamUid}`;
    }

    getTeamsOfUser(userId): string{
        return `${this.dataCollectorService.baseurl()}/user/${userId}/teams`;
    }

    getUserURL(userId: string): string {
        return `${this.dataCollectorService.baseurl()}/user/` + userId;
    }

    getContractUrl(contractUid: string): string {
        return `${this.jobAPIUrls.contractUrl}/${contractUid}`;
    }

    setSelectedRoute(route): void{
        this.selectedRoute = route;
    }

    getSelectedRoute(): any{
        return this.selectedRoute;
    }

    getAssignRouteUrl(routeId): string{
        return `${this.dataCollectorService.baseurl()}/routes/${routeId}/job`;
    }

    getServiceTaskApi(taskId): string{
        return `${this.dataCollectorService.baseurl()}/service_tasks/${taskId}`;
    }

    getServiceTaskAssignUrl(taskId): string{
        return `${this.dataCollectorService.baseurl()}/service_tasks/${taskId}/assign`;
    }

    getServiceTaskStatusUrl(taskId): string{
        return `${this.dataCollectorService.baseurl()}/service_tasks/${taskId}/status`;
    }

    getInspectionFormDetails(formId): string{
        return `${this.dataCollectorService.baseurl()}/assets/inspection_form/${formId}`;
    }

    getJobUpdateUrl(jobId: string): string {
        return `${this.dataCollectorService.baseurl()}/jobs/${jobId}/update`;
    }

    getJobAttachmentUrl(jobId: string): string {
        return `${this.dataCollectorService.baseurl()}/jobs/${jobId}/attachments`;
    }

    updateJobDetails(payload): Observable<any> {
        return this.dataCollectorService.putData(this.jobAPIUrls.jobsUrl, payload).pipe(
            tap((response: any) => {
                this.castJobEvent('update', {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    job_uid: response.data.job_uid,
                });
            }));
    }

    includeJobToProject(url): Observable<any>{
        const projectUrl = `${this.dataCollectorService.baseurl()}/${url}`;
        return this.dataCollectorService.postData(projectUrl, {});
      }

    getTimeLogEntry(jobId): any{
        const timelogUrl = `${this.dataCollectorService.baseurl()}/jobs/${jobId}/timelog`;
        return this.dataCollectorService.getData(timelogUrl);
    }
    postTimeLogEntry(payload): any{
        const timelogUrl = `${this.dataCollectorService.baseurl()}/jobs/${payload.job_uid}/timelog`;
        return this.dataCollectorService.postData(timelogUrl, payload);
    }
    updateTimeLogEntry(jobUid: any,timelogUid: any,payload): any{
        const timelogUrl = `${this.dataCollectorService.baseurl()}/jobs/${jobUid}/timelog_summary/${timelogUid}`;
        return this.dataCollectorService.putData(timelogUrl, payload);
    }
    deleteTimeLogEntry(payload): any{
        const timelogUrl = `${this.dataCollectorService.baseurl()}/jobs/${payload?.job_uid}/timelog/${payload?.timelog_uid}?remove_associated_entry=true`;
        return this.dataCollectorService.deleteData(timelogUrl);
    }
    recurringJobScheduleUrl(isCreateJobPastDate: boolean): string{
        return `${this.dataCollectorService.baseurl()}/recurring_job/schedule?create_jobs_for_past_date=${isCreateJobPastDate}`;
    }
    updateJobAcceptanceUrl(jobId: string, acceptanceStatus: any): string{
        return `${this.dataCollectorService.baseurl()}/jobs/${jobId}/accept?type=${acceptanceStatus}`;
    }

    addProject(projectId: string, jobId: string, phaseId: any): any{
        const phaseUrl = `?phase_uid=${phaseId}`;
        const addProjectUrl = `${this.dataCollectorService.baseurl()}/projects/${projectId}/jobs/${jobId}${phaseId != null ? phaseUrl : ''}`;
        return this.dataCollectorService.postData(addProjectUrl, {});
    }

    getTerritoryConflicts(jobId: any): Observable<any>{
        const url = `${this.dataCollectorService.baseurl()}/jobs/${jobId}/territory/conflicts`;
        return this.dataCollectorService.getData(url);
    }

    getServiceTerritoryDetails(payload: any): Observable<any>{
        const url = `${this.dataCollectorService.baseurl()}/jobs/territory/match`;
        return this.dataCollectorService.postData(url,payload);
    }
    projectsDetailsUrl(projectsUid: string): string{
        return this.jobAPIUrls.projectsUrl + `/${projectsUid}`;
    }

    castJobEvent(event, data): void{
        this._eventBus.cast('sdk:job:' + event, data);
    }

    fetchAttachmentCount(module: string, moduleUid: string): void {
    const params = {
      ...this.defaultFilterOptions.filterOptions,
      'filter.module': module,
      'filter.module_uid': moduleUid
    };

    if (this.defaultFilterOptions.filterOptions['filter.type'] === '') {
      params['filter.type'] = 'IMAGE,VIDEO';
    }

    const url: string = this.jobAPIUrls?.attachmentCount;

    this.dataCollectorService.getData(url, params).pipe(
      map((res: any) => res?.attachment_count ?? 0),
      catchError((err: any) => {
        return of(0);
      })
    ).subscribe(count => {
      this.attachmentCountSubject.next(count);
    });
  }

}
